import type { ExtendedConstraints, CapabilityConfig } from '../types';

export const id = 'iframed-runtime';

export enum Events {}
export enum Actions {
  Ready = 'iframed-runtime:ready',
  Pause = 'iframed-runtime:pause',
  Resume = 'iframed-runtime:resume',
  SetHeight = 'iframed-runtime:set-height',
}

export type SetHeightPayload = string;

export type Constraints = ExtendedConstraints<{
  actions: Actions;
  actionPayloadTuple:
    | [Actions.Ready]
    | [Actions.Pause]
    | [Actions.SetHeight, SetHeightPayload];
}>;

export function isValidConfig(v: CapabilityConfig): boolean {
  return typeof v === 'object';
}
